module.exports = __webpack_public_path__ + "static/media/linkedin_dp_overlay_round.32755f13.png";